/* snoozyn - mobile sticky buy bar. Product pages only, 749px and below.
   It does NOT duplicate the product form: the bar's button submits the real one,
   so variant state, sold-out state and the cart drawer stay Dawn's behaviour.
   Added 16 Sept 2026. To remove: delete this file and its <script> tag in meta-tags.liquid.

   2 Oct 2026 - visibility fix. Visibility is recomputed from the button's position on every
   scroll/resize (rAF-throttled), with an IntersectionObserver kept as an extra trigger.
   The price watcher observes <product-info> rather than a .price node Dawn may swap out.

   13 Oct 2026 (SNZ-BUYBAR-FIRST-SCREEN) - ad visitors land on a phone with the real Add to
   Cart about two screens down, so the bar used to stay hidden for the whole first view.
   It now shows whenever the real button is OFF SCREEN in either direction (above OR below
   the viewport) and hides only while the real button itself is visible. It boots within
   ~1.2 s instead of waiting up to 4 s for idle, and the small line above the price shows
   the UK free-delivery offer to UK shoppers instead of repeating the product title.
   While the slim cookie bar is on screen the buy bar waits, so the two never stack. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 749px)');
  var bar = null;
  var io = null;
  var priceObserver = null;
  var buttonObserver = null;
  var ticking = false;

  function realAddButton() {
    return document.querySelector('product-info product-form button[name="add"]')
        || document.querySelector('product-form button[name="add"]')
        || document.querySelector('form[action*="/cart/add"] button[name="add"]');
  }

  function realForm(btn) {
    return btn ? btn.closest('form') : null;
  }

  function priceSource() {
    return document.querySelector('.product__info-wrapper .price')
        || document.querySelector('.product__info-container .price')
        || document.querySelector('.price');
  }

  function priceText() {
    var el = priceSource();
    if (!el) return '';
    // Dawn renders regular + sale + unit price in one block; take the visible line only.
    var sale = el.querySelector('.price__sale:not([hidden]) .price-item--sale');
    var reg = el.querySelector('.price__regular .price-item--regular');
    // 1 Nov 2026 (INP): read Dawn's on-sale class instead of offsetParent, which forced a full
    // layout on every price mutation (180-340 ms per colour tap on a 240-variant set, phone CPU).
    var pick = (sale && el.classList.contains('price--on-sale')) ? sale : (reg || sale);
    var txt = (pick || el).textContent || '';
    return txt.replace(/\s+/g, ' ').replace(/Regular price|Sale price|Unit price|per\s*$/gi, '').trim();
  }

  // UK shoppers see the offer line; everyone else sees the product title as before.
  function offerLine(fallback) {
    var S = window.Shopify || {};
    var country = (S.country || '').toUpperCase();
    var currency = (S.currency && S.currency.active) || '';
    if (country === 'GB' || (!country && currency === 'GBP')) {
      return 'Free UK delivery';
    }
    return fallback;
  }

  // 20 Oct 2026, audit93 F18: the bar showed the price but never WHAT it adds.
  // Short summary of the picked options ("Mint Green · King"), from the real
  // picker. Options with a single value (e.g. "Under 35cm") and a size still to
  // choose are left out; a size's "(3 ft)" tail is dropped to keep it short.
  function variantText() {
    var vs = document.querySelector('product-info variant-selects') || document.querySelector('variant-selects');
    if (!vs) return '';
    var out = [];
    Array.prototype.forEach.call(vs.querySelectorAll('fieldset'), function (fs) {
      var all = fs.querySelectorAll('input[type="radio"]');
      if (all.length < 2) return;
      var c = fs.querySelector('input[type="radio"]:checked');
      if (!c) return;
      // The pill's own label when it has visible text (Set pills show "Full set"), else the value.
      var lab = fs.querySelector('label[for="' + c.id + '"]');
      var txt = '';
      if (lab) {
        var k = lab.cloneNode(true);
        // 1 Nov 2026: also drop the per-pill price tag (.snz-pp, snz-size-prices.js) - the bar shows the price beside it.
        Array.prototype.forEach.call(k.querySelectorAll('.visually-hidden, .snz-pp'), function (h) { h.remove(); });
        txt = k.textContent.replace(/\s+/g, ' ').trim();
      }
      out.push((txt || String(c.value)).replace(/\s*\(.*\)\s*$/, '').trim());
    });
    Array.prototype.forEach.call(vs.querySelectorAll('select'), function (sel) {
      if (sel.options.length < 2) return;
      var o = sel.options[sel.selectedIndex];
      if (o) out.push(String(o.value).replace(/\s*\(.*\)\s*$/, '').trim());
    });
    return out.filter(Boolean).join(' · ');
  }

  function injectStyles() {
    if (document.getElementById('snz-buybar-css')) return;
    var s = document.createElement('style');
    s.id = 'snz-buybar-css';
    s.textContent =
      '.snz-buybar{position:fixed;left:0;right:0;bottom:0;z-index:5;' +
      'display:flex;align-items:center;gap:12px;' +
      'padding:10px 16px calc(10px + env(safe-area-inset-bottom,0px));' +
      'background:#FDFDFC;border-top:1px solid #D9E2DF;' +
      'box-shadow:0 -2px 12px rgba(31,36,33,.06);' +
      'transform:translateY(110%);transition:transform .22s cubic-bezier(.16,1,.3,1);' +
      'visibility:hidden;}' +
      '.snz-buybar.is-visible{transform:translateY(0);visibility:visible;}' +
      '.snz-buybar__text{min-width:0;flex:1 1 auto;line-height:1.25;}' +
      '.snz-buybar__title{display:block;font-size:12px;color:#5A6360;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
      '.snz-buybar__offer{display:inline-block;margin-left:8px;font-size:11px;color:#5A6360;white-space:nowrap;}' +
      '.snz-buybar__price{display:inline-block;font-size:16px;font-weight:600;color:#1F2421;' +
      'font-variant-numeric:tabular-nums;}' +
      '.snz-buybar__btn{flex:0 0 auto;min-height:46px;padding:12px 26px;border:0;' +
      'background:#1F2421;color:#fff;font-size:12px;font-weight:600;letter-spacing:.12em;' +
      'text-transform:uppercase;border-radius:0;cursor:pointer;}' +
      '.snz-buybar__btn[disabled]{opacity:.5;cursor:default;}' +
      '@media (prefers-reduced-motion: reduce){.snz-buybar{transition:none;}}' +
      '@media (min-width: 750px){.snz-buybar{display:none !important;}}';
    document.head.appendChild(s);
  }

  function build() {
    var btn = realAddButton();
    var form = realForm(btn);
    if (!btn || !form || bar) return;

    injectStyles();

    var titleEl = document.querySelector('.product__title h1, .product__info-wrapper h1, h1');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';

    bar = document.createElement('div');
    bar.className = 'snz-buybar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to bag'); // 20 Oct 2026, audit #94

    var text = document.createElement('span');
    text.className = 'snz-buybar__text';
    var t = document.createElement('span');
    t.className = 'snz-buybar__title';
    t.textContent = variantText() || title; // 20 Oct 2026, audit93 F18
    var p = document.createElement('span');
    p.className = 'snz-buybar__price';
    p.textContent = priceText();
    text.appendChild(t);
    text.appendChild(p);
    // 20 Oct 2026, audit93 F18: the UK offer moved beside the price so the line above can name the variant.
    var off = offerLine('');
    if (off) {
      var o = document.createElement('span');
      o.className = 'snz-buybar__offer';
      o.textContent = off;
      text.appendChild(o);
    }

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'snz-buybar__btn';
    b.textContent = btn.textContent.replace(/\s+/g, ' ').trim() || 'Add to bag'; // 20 Oct 2026, audit #94
    b.disabled = btn.disabled && !sizePending(btn);

    b.addEventListener('click', function () {
      var live = realAddButton();
      var liveForm = realForm(live);
      // 19 Oct 2026 (audit #9): sleepwear with no size chosen - take the shopper to the size row.
      if (live && sizePending(live)) { window.snzSizeRequired.prompt(liveForm || live); return; }
      if (!live || !liveForm || live.disabled) return;
      // Submit the REAL form so product-form.js handles it (cart drawer, errors, variant).
      if (typeof liveForm.requestSubmit === 'function') {
        liveForm.requestSubmit(live);
      } else {
        live.click();
      }
    });

    bar.appendChild(text);
    bar.appendChild(b);
    document.body.appendChild(bar);

    bar.__btn = b;
    bar.__price = p;
    bar.__title = t;
    bar.__fallback = title;

    watchPrice();
    watchButton();
    observe();
    update();
  }

  // 19 Oct 2026 (audit #9): true while a sleepwear page still needs a size (assets/snz-size-required.js).
  function sizePending(live) {
    return !!(window.snzSizeRequired && window.snzSizeRequired.pending(live));
  }

  function syncFromForm() {
    if (!bar) return;
    var live = realAddButton();
    if (!live) return;
    // Size still to choose: keep the bar's button live ("Choose a size") so it can lead to the picker.
    bar.__btn.disabled = live.disabled && !sizePending(live);
    var label = live.textContent.replace(/\s+/g, ' ').trim();
    if (label) bar.__btn.textContent = label;
    bar.__price.textContent = priceText();
    bar.__title.textContent = variantText() || bar.__fallback; // 20 Oct 2026, audit93 F18
  }

  // 1 Nov 2026 (INP): Dawn's variant re-render fires many mutation batches; sync the bar once,
  // after the next frame has painted, so it never sits inside the tap's response time.
  var syncQueued = false;
  function scheduleSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(function () {
      setTimeout(function () { syncQueued = false; syncFromForm(); }, 0);
    });
  }

  function watchPrice() {
    if (priceObserver) return;
    var src = priceSource();
    var root = (src && src.closest('product-info')) || document.querySelector('product-info') || src;
    if (!root) return;
    priceObserver = new MutationObserver(scheduleSync);
    priceObserver.observe(root, { childList: true, subtree: true, characterData: true });
  }

  function watchButton() {
    var live = realAddButton();
    if (!live || buttonObserver) return;
    buttonObserver = new MutationObserver(scheduleSync);
    buttonObserver.observe(live, { attributes: true, childList: true, subtree: true });
  }

  function setVisible(on) {
    if (!bar) return;
    bar.classList.toggle('is-visible', !!on && MQ.matches && !drawerOpen());
  }

  function drawerOpen() {
    var d = document.querySelector('cart-drawer.active, .menu-drawer-container.menu-opening, details-modal[open]');
    return !!d || document.body.classList.contains('overflow-hidden') || consentShowing();
  }

  // 13 Oct 2026: the slim cookie bar also sits at the bottom on phones. Only one bottom bar at
  // a time: the buy bar waits until the shopper has answered the cookie bar.
  function consentShowing() {
    var c = document.getElementById('shopify-pc__banner');
    if (!c) return false;
    var cs = window.getComputedStyle(c);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    var r = c.getBoundingClientRect();
    return r.height > 0 && r.top < (window.innerHeight || 0);
  }

  // Source of truth: show the bar whenever the real button is wholly off screen,
  // above OR below the viewport; hide it while the real button is in view.
  function update() {
    ticking = false;
    if (!bar) return;
    var live = realAddButton();
    if (!live) { setVisible(false); return; }
    var r = live.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) { setVisible(false); return; }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    setVisible(r.bottom < 0 || r.top > vh);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function observe() {
    var live = realAddButton();
    if (!live || io) return;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function () { requestUpdate(); }, { threshold: 0 });
      io.observe(live);
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    window.addEventListener('pageshow', requestUpdate);
    // Re-check once the cookie bar is answered (Shopify's event, plus any tap as a fallback).
    document.addEventListener('visitorConsentCollected', function () { setTimeout(requestUpdate, 200); });
    document.addEventListener('click', function () { setTimeout(requestUpdate, 400); }, true);
  }

  function teardown() {
    if (io) { io.disconnect(); io = null; }
    if (priceObserver) { priceObserver.disconnect(); priceObserver = null; }
    if (buttonObserver) { buttonObserver.disconnect(); buttonObserver = null; }
    window.removeEventListener('scroll', requestUpdate);
    window.removeEventListener('resize', requestUpdate);
    window.removeEventListener('pageshow', requestUpdate);
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    bar = null;
  }

  function boot() {
    if (!document.querySelector('product-form, form[action*="/cart/add"]')) return;
    if (MQ.matches) { build(); } else { teardown(); }
  }

  // Exposed so the bar can be exercised without a real scroll.
  window.__snzBuyBar = {
    show: function () { setVisible(true); },
    hide: function () { setVisible(false); },
    update: update,
    state: function () {
      return {
        built: !!bar,
        visible: !!(bar && bar.classList.contains('is-visible')),
        price: bar ? bar.__price.textContent : null,
        label: bar ? bar.__btn.textContent : null,
        disabled: bar ? bar.__btn.disabled : null,
        mq: MQ.matches
      };
    },
    sync: syncFromForm
  };

  /* SNZ-BUYBAR-LAZY (9 Oct), tightened 13 Oct: build after the page has painted (first
     scroll, idle, or 1.2 s at the latest) so it stays off the critical load path but is
     on screen early in the first view. */
  function lazyBoot() {
    var started = false;
    function start() {
      if (started) return;
      started = true;
      window.removeEventListener('scroll', start);
      boot();
    }
    window.addEventListener('scroll', start, { passive: true });
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(start, { timeout: 1200 });
    } else {
      setTimeout(start, 1200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lazyBoot);
  } else {
    lazyBoot();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', boot);
  else if (MQ.addListener) MQ.addListener(boot);
})();
